import { Accordion, AccordionSummary, List, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ArrowDropdown, ArrowUpIcon } from "../../../../../../../assets/icons";
import { useFiltersRegistry } from "../../../../../../../context/FiltersProvider";
import { FilterDefinition } from "../../../../../../../context/FiltersProvider/types";
import { RootCauseFilterListItem } from "../RootCauseFilterListItem";

type Props = {
	title: string;
	items: FilterDefinition[];
	expanded: boolean;
	icon?: React.ReactNode;
	onToggle: () => void;
	onSelect: (filter: FilterDefinition) => void;
	isPerimeterCard: boolean;
};

export const RootCauseFiltersAccordion = ({
	title,
	items,
	expanded,
	onToggle,
	onSelect,
	icon,
	isPerimeterCard,
}: Props) => {
	const { t } = useTranslation("common");
	const { rootCauseState } = useFiltersRegistry();

	const hasItems = items.length > 0;

	const selectedPerimeterIds = rootCauseState.perimeter.map((f) => f.id);

	return (
		<Accordion expanded={expanded} onChange={onToggle}>
			<AccordionSummary
				sx={{
					position: "sticky",
					top: 0,
					backgroundColor: "background.paper",
					zIndex: 10000,
					borderBottom: expanded ? "1px solid" : "none",
					borderColor: expanded ? "divider" : "transparent",
				}}
			>
				<Stack direction="row" justifyContent="space-between" alignItems="center" width="100%" px={2} py={0.5}>
					<Stack direction={"row"} spacing={1} alignItems="center">
						{icon}
						<Typography variant="subtitle2">{title}</Typography>
					</Stack>

					{expanded ? <ArrowUpIcon sx={{ mr: 0.5 }} /> : <ArrowDropdown sx={{ mr: 0.5 }} />}
				</Stack>
			</AccordionSummary>

			{hasItems ? (
				<List>
					{items.map((filter) => (
						<RootCauseFilterListItem
							key={filter.id}
							filter={filter}
							onSelect={onSelect}
							selected={selectedPerimeterIds.includes(filter.id) && isPerimeterCard}
						/>
					))}
				</List>
			) : (
				<Typography px={2} py={1} variant="body2">
					{t("no filters")}
				</Typography>
			)}
		</Accordion>
	);
};
